module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow-20b07dc1c7393d4255b520925e5de7f7.svg";